import React from 'react';
import { styled } from '@teko/ui';
import { Row, useTheme } from '@teko/ds-desktop';
import { HomeLocationColored, LocationColored } from '@teko/ds-icon';

interface Props {
  isChoice: boolean;
  terminalName: string;
  distance: number;
  terminalAddress: string;
  onClick: () => void;
}

export const TerminalPickerItem = ({
  isChoice,
  terminalName,
  distance,
  terminalAddress,
  onClick,
}: Props) => {
  const { colors } = useTheme();

  return (
    <Wrapper
      backgroundColor={isChoice ? colors.primary50 : colors.white}
      borderColor={isChoice ? colors.primary : '#0000000f'}
      onClick={onClick}
    >
      <Row justify="space-between">
        <Title>{terminalName}</Title>
        <Row>
          <SubTitle
            style={{
              color: colors.primary,
              textDecoration: 'underline',
              marginRight: 4,
            }}
          >
            {distance?.toFixed(2)} km
          </SubTitle>
          <LocationColored size={20} />
        </Row>
        <Row justify="start" style={{ marginTop: 8, width: '100%' }}>
          <HomeLocationColored size={20} />
          <SubTitle
            style={{
              marginLeft: 8,
              width: '90%',
            }}
          >
            {terminalAddress}
          </SubTitle>
        </Row>
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ backgroundColor?: string; borderColor?: string }>(
  ({ backgroundColor = '#ffff', borderColor = '#0000000f' }) => `
  border-radius: 8px;
  background-color: ${backgroundColor};
  padding: 8px;
  width: 100%;
  max-height: 400px;
  border: 1px solid ${borderColor};
  margin-top: 8px;
  cursor: pointer
`,
);

const Title = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const SubTitle = styled.span`
  font-size: 12px;
  font-weight: 500;
`;
